// UpsellChildren — part of the product option modal (ProductOptionView).
import { getExtraUpsellGroup } from '../normalize';
import OptionPriceDelta from './OptionPriceDelta.jsx';

// Variant upsell groups, rendered as a dashed-rail chip block directly under the
// selected variant / variant-group option. Shared by the card list and the row
// list so both variant presentations get the same treatment.
export default function UpsellChildren({
  group,
  selectedOption,
  groupKeyPrefix,
  selections,
  onToggle,
  t,
}) {
  const upsellGroups = getExtraUpsellGroup(selectedOption);
  if (!upsellGroups || !upsellGroups.length) return null;
  const variantGroupId =
    group.variant_group_id ?? (group.id === 'single-variants' ? null : group.id);

  return (
    <div className="po-children">
      {upsellGroups.map((upsellGroup, groupIndex) => {
        const items = upsellGroup.upsell_items ?? upsellGroup.items ?? upsellGroup.options ?? [];
        if (!items.length) return null;
        const rawGroupId =
          upsellGroup.group_id ?? upsellGroup.id ?? upsellGroup.upsell_group_id ?? groupIndex;
        const key = `${groupKeyPrefix}_${selectedOption?.id || 'opt'}_${rawGroupId}`;
        return (
          <div key={key} className="po-child-block">
            <div className="po-child-label">
              <span className="po-child-label-title">
                {upsellGroup.name || t('upsellingLabel', 'Add extras')}
              </span>
              <span className="po-child-label-hint">
                {t('optionalPickOne', 'optional · pick one')}
              </span>
            </div>
            <div className="po-chip-row">
              {items.map((item, itemIndex) => {
                const itemId = item.id ?? item.upsell_item_id ?? itemIndex;
                const isSelected = selections[key]?.id === itemId;
                const price = item.upsell_price ?? item.price ?? item.price_delta ?? 0;
                const name = item.display_name ?? item.name ?? item.title;
                return (
                  <button
                    key={itemId}
                    type="button"
                    aria-pressed={isSelected}
                    onClick={() =>
                      onToggle(key, {
                        id: itemId,
                        name,
                        price,
                        upsell_group_id: rawGroupId,
                        upsell_item_id: item.upsell_item_id ?? item.id ?? itemId,
                        modifier_id: item.modifier_id ?? item.upsell_item_id ?? item.id ?? itemId,
                        variant_group_id: variantGroupId,
                        variant_id: selectedOption?.variant_id ?? selectedOption?.id,
                        raw: item,
                      })
                    }
                    className={`po-chip ${isSelected ? 'is-selected is-extra' : ''}`}
                  >
                    <span>{name}</span>
                    {price > 0 ? (
                      <OptionPriceDelta amount={price} className="po-chip-delta" />
                    ) : null}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
